/**
 * Decode percent-encoding in query values (e.g. %40 → @).
 * Repeats while the value still looks percent-encoded so double-encoded
 * reset links (User=name%2540domain) still yield a plain email.
 * @param {string} [value]
 * @returns {string}
 */
export const decodeQueryValue = (value = "") => {
  let decoded = String(value ?? "");
  for (let i = 0; i < 3; i++) {
    if (!/%[0-9A-Fa-f]{2}/.test(decoded)) break;
    try {
      const next = decodeURIComponent(decoded);
      if (next === decoded) break;
      decoded = next;
    } catch {
      break;
    }
  }
  return decoded;
};

export const parseQueryURL = (url) => {
  const queryObj = {};
  if (url) {
    for (const query of url?.slice(1).split("&")) {
      const eq = query.indexOf("=");
      const rawKey = eq === -1 ? query : query.slice(0, eq);
      const rawVal = eq === -1 ? "" : query.slice(eq + 1);
      if (rawKey !== "") {
        queryObj[decodeQueryValue(rawKey)] = decodeQueryValue(rawVal);
      }
    }
  }
  return queryObj;
};

/**
 * Parse query params from location.search or the hash fragment (/#/?token=…).
 * @param {string} [search]
 * @param {string} [hash]
 * @returns {Record<string, string>}
 */
export const parseAuthQueryParams = (search = "", hash = "") => {
  const fromSearch = parseQueryURL(search);
  if (Object.keys(fromSearch).length > 0) {
    return fromSearch;
  }

  const hashBody = String(hash || "").replace(/^#\/?/, "");
  const qIndex = hashBody.indexOf("?");
  const hashQuery =
    qIndex >= 0
      ? hashBody.slice(qIndex)
      : hashBody.startsWith("?")
        ? hashBody
        : "";
  return parseQueryURL(hashQuery);
};

export const isPasswordResetRequiredError = (err) => {
  return (
    err?.status === 403 &&
    err?.response?.body?.code === "PASSWORD_RESET_REQUIRED"
  );
};
